import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { convertToWebp } from '../services'

// Determine output filename based on input files
const getOutputFilename = (files: File[]) => {
    if (files.length === 1) {
        const name = files[0].name.replace(/\.[^/.]+$/, '')
        return `${name}.webp`
    }
    return 'converted_webp.zip'
}

export const useConvertWebp = () => {
    return useMutationWithHandler(
        { mutationFn: convertToWebp },
        {
            successMessage: 'Chuyển đổi thành công!',
            errorMessage: 'Chuyển đổi thất bại. Vui lòng thử lại.',
            showSuccessToast: false,
            reactQueryKeys: [],
            onSuccess: (blob, variables) => {
                const filename = getOutputFilename(variables.files)
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = filename
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                URL.revokeObjectURL(url)
            },
        }
    )
}
